import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertService, ConstantService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RUPropertiesStatusService } from '../ru-properties-status.service';
import { RUPropertiesStatus } from '../ru-properties-status';
import { RUPropertiesStatusComponent } from '../ru-properties-status/ru-properties-status.component';
import { PropertyService } from '@app/_components/property';
import { ListingQualityStatusService } from '@app/_components/listing-quality-status/listing-quality-status.service';
import { ReportService } from '@app/_components/report';
import { PercentageValuesPositiveAndNegative } from '@app/_helpers';
import { ImportExportComponent } from '@app/_components/_helpers/import-export/import-export.component';

@Component({
    selector: 'app-ru-properties-status-list',
    templateUrl: './ru-properties-status-list.component.html',
    styleUrls: ['./ru-properties-status-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class RUPropertiesStatusListComponent implements OnInit {
	@ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
    properties: any[]=[];
    listingStatuses: any;
	propertyValues = [];
    booleans = false;
    contentStatuses: any;
    aRIStatuses: any;
	percentageValuesPositiveAndNegative: any = PercentageValuesPositiveAndNegative
    channels: any[];
	constructor(
		private ruPropertiesStatusService: RUPropertiesStatusService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		public constantService: ConstantService,
		private propertyService: PropertyService,
		private reportService: ReportService,
		private listingQualityStatusService: ListingQualityStatusService,
	) {
		this.statuses = ruPropertiesStatusService.statuses;
		this.listingStatuses = listingQualityStatusService.statusesForPropertyStatus;
		this.booleans = ruPropertiesStatusService.booleans;
		this.contentStatuses = ruPropertiesStatusService.contentStatuses;
		this.aRIStatuses = ruPropertiesStatusService.aRIStatuses;
		this.channels = this.constantService.refSrcImages;
	}



	// data
	@Input() shortTermRentalId: any;
	@Input() shortTermRental: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	ruPropertiesStatuss: any;
	ruPropertiesStatus: RUPropertiesStatus;
	isSearching = false;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'ruChannelId', header: 'Channels', width: 'auto' },
		{ field: 'puId', header: 'PUID', width: 'auto' },
		{ field: 'clusterActive', header: 'Cluster Active', width: 'auto' },
		{ field: 'unitActive', header: 'Unit Active', width: 'auto' },
		{ field: 'rateActive', header: 'Rate Active', width: 'auto' },
		{ field: 'contentStatus', header: 'Content Status', width: 'auto' },
		{ field: 'aRIStatus', header: 'aRIStatus', width: 'auto' },
		{ field: 'rateMarkup', header: 'Rate Markup', width: 'auto' },
		{ field: 'rateId', header: 'RateId', width: 'auto' },
		{ field: 'unitId', header: 'UnitId', width: 'auto' },
		{ field: 'externalUnitId', header: 'External UnitId', width: 'auto' },
		{ field: 'propertyId', header: 'PropertyId', width: 'auto' },
	];

	ngOnInit(): void {
		if(this.shortTermRentalId){
			this.fetchPropertyById();
		}else{
			this.fetchProperties();
		}
		
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			// console.log('Error: ' + error);
		}
	}
	
	getRefSrcImage(refSrcId) {
		return this.constantService.refSrcImages.find(function(item) { return item.ruChannelId === refSrcId })?.imgurl;
	}

	getRefSrcUrl(refSrc: any) {
		const ruChannelId = this.constantService.refSrcImages.find(function(item) { return item.ruChannelId === refSrc?.ruChannelId })?.ruChannelId;
		if(ruChannelId){
			if(ruChannelId == 420853){ // VRBO
				return "https://www.vrbo.com/"+refSrc?.externalUnitId;
			}
			if(ruChannelId == 426592){ // AirBnb
				return "https://www.airbnb.com/rooms/"+refSrc?.externalUnitId;
			}
			if(ruChannelId == 421402){ // Expedia
				return "https://www.expedia.com/h"+refSrc?.clusterId+".Hotel-Information";
			}
			if(ruChannelId == 568092){ // Merriot
				return "https://homes-and-villas.marriott.com/en/properties/"+refSrc?.externalUnitId;
			}

		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		// console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.ruPropertiesStatusId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ruPropertiesStatus-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if(this.shortTermRentalId)
			{
				// show only shortTermRentals that are assigned to this shortTermRentalIdFilter
				let shortTermRentalIdFilter = { 'puId': { 'value': this.shortTermRentalId, 'matchMode': 'in' } };
				Object.assign(event.filters, shortTermRentalIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ruPropertiesStatusService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ruPropertiesStatuss = res.data.ruPropertiesStatuss;
						// console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						// console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ruPropertiesStatuss = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			// console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		// console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(ruPropertiesStatus: RUPropertiesStatus) {
		try {
			this.formLoading = true;
			this.ruPropertiesStatusService.update(ruPropertiesStatus)
				.subscribe(
					(res: any) => {
						// console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ruPropertiesStatuss.map((ruPropertiesStatus, i) => {
							if (ruPropertiesStatus.ruPropertiesStatusId === res.data.ruPropertiesStatus.ruPropertiesStatusId) {
								this.ruPropertiesStatuss[i] = res.data.ruPropertiesStatus;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						// console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(ruPropertiesStatus: any) {
		try {
			// stop here if form is invalid
			// console.log('Delete Submitted: ' + JSON.stringify(ruPropertiesStatus));

			this.formLoading = true;
			this.ruPropertiesStatusService.delete(ruPropertiesStatus.ruPropertiesStatusId)
				.subscribe(
					(res: any) => {
						// console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ruPropertiesStatuss.splice(this.ruPropertiesStatuss.indexOf(ruPropertiesStatus), 1);
						this.recordTotal = this.ruPropertiesStatuss.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'RUPropertiesStatus ' + ruPropertiesStatus.ruPropertiesStatusId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						// console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'RUPropertiesStatus ' + ruPropertiesStatus.ruPropertiesStatusId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add RUPropertiesStatus'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RUPropertiesStatusComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				// console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addRUPropertiesStatusCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(ruPropertiesStatus: RUPropertiesStatus) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ruPropertiesStatus: ruPropertiesStatus,
			title: 'Edit RUPropertiesStatus'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RUPropertiesStatusComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				// console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateRUPropertiesStatusCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				// console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteRUPropertiesStatusCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addRUPropertiesStatusCB(ruPropertiesStatus: RUPropertiesStatus) {
		// console.log('Adding RUPropertiesStatus: ' + JSON.stringify(ruPropertiesStatus));
		// if we don't have a ruPropertiesStatuss array yet...
		if (!this.ruPropertiesStatuss) {
			this.ruPropertiesStatuss = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ruPropertiesStatuss.unshift(ruPropertiesStatus);

		// no idea what this is but it is required to update the array
		this.ruPropertiesStatuss = [...this.ruPropertiesStatuss];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RUPropertiesStatus ' + ruPropertiesStatus.ruPropertiesStatusId + ' Added', life: 3000 });
	}

	updateRUPropertiesStatusCB(ruPropertiesStatus: RUPropertiesStatus) {
		// console.log('Updating RUPropertiesStatus: ' + JSON.stringify(ruPropertiesStatus));
		let itemIndex = this.ruPropertiesStatuss.findIndex((item: any) => item.ruPropertiesStatusId === ruPropertiesStatus.ruPropertiesStatusId);
		this.ruPropertiesStatuss[itemIndex] = ruPropertiesStatus;

		// no idea what this is but it is required to update the array
		this.ruPropertiesStatuss = [...this.ruPropertiesStatuss];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RUPropertiesStatus ' + ruPropertiesStatus.ruPropertiesStatusId + ' Updated', life: 3000 });
	}

	deleteRUPropertiesStatusCB(ruPropertiesStatus: RUPropertiesStatus) {
		// console.log('Removing RUPropertiesStatus: ' + ruPropertiesStatus);
		this.ruPropertiesStatuss.splice(this.ruPropertiesStatuss.indexOf(ruPropertiesStatus), 1);
		this.recordTotal = this.ruPropertiesStatuss.length;

		// no idea what this is but it is required to update the array
		this.ruPropertiesStatuss = [...this.ruPropertiesStatuss];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RUPropertiesStatus ' + ruPropertiesStatus.ruPropertiesStatusId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.ruPropertiesStatuss ? this.first === (this.ruPropertiesStatuss.length - this.rows) : true; }
	isFirstPage(): boolean { return this.ruPropertiesStatuss ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(ruPropertiesStatus: any) {
		if (ruPropertiesStatus?.status) {
			const status = this.statuses.find((e: any) => e.value == ruPropertiesStatus.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}
	
	getResStatusColor(resStatus: any) {
		if (resStatus == true) {
			return '#32CD32';
		}
		if (resStatus == false) {
			return '#f16666 ';
		}
	}
	
	getListingStatusColor(resStatus: any) {
		const shortTermRental = this.properties.find((e: any) => e.shortTermRentalId == resStatus);
		// console.log("shortTermRental :" + JSON.stringify(shortTermRental));
			const listingStatus = this.listingStatuses.find((e: any) => e.value === shortTermRental?.listingStatus);
		if (listingStatus?.value === 0) {
			return '#32CD32';
		}else {
			return '#f16666 ';
		}
	}
	
	getContentStatusColor(contentStatus: any) {
		// console.log("resStatus :" + contentStatus);
		if (contentStatus == 'Ok' || contentStatus == 'ok' || contentStatus == 'oK' || contentStatus == 'OK') {
			return '#32CD32';
		}else {
			return '#f16666 ';
		}
	}
	
	getCMPullPropertiesStatusRS() {
		this.isSearching = true;
		try {
			this.ruPropertiesStatusService.getCMPullPropertiesStatusRS()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.loadLazy(this.lazyLoadEvent);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Get channels data successfully" });
						this.isSearching = false;
					},
					err => {
						// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Get channels data failed: ' + err.message });
						this.isSearching = false;
					},
					() => {this.isSearching = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Get channels data failed: ' + error.message });
		}
	}
	
	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			this.isSearching = true;
			try {
				this.reportService.propertySummaryList()
					.subscribe(
						res => {
							 // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.propertySummaryList;
							for(var i = 0; i <= res.data.propertySummaryList.length ; i++){
								var propertyValueObj = {
									name: res.data.propertySummaryList[i]?.propertyCode,
									value: res.data.propertySummaryList[i]?.shortTermRentalId
								}
					             this.propertyValues.push(propertyValueObj);
					         }
							this.isSearching = false;
							return this.properties;
						},
						err => {
							// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.isSearching = false;
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				this.isSearching = false;
				// console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// // console.log('properties are ' + this.properties);
			this.isSearching = false;
			return (this.properties);
		}
	}
	
	fetchPropertyById() {
			this.isSearching = true;
			try {
				this.propertyService.findById(this.shortTermRentalId)
					.subscribe(
						res => {
							 // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties.push(res.data.property);
							this.isSearching = false;
							return this.properties;
						},
						err => {
							// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.isSearching = false;
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				this.isSearching = false;
				// console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}
	
	getPropertyCode(puid: any) {
		if (puid) {
			const shortTermRental = this.properties.find((e: any) => e.shortTermRentalId == puid);
			if(shortTermRental){
				return shortTermRental?.propertyCode;
			}else{
				return puid;
			}
		}
		else {
			return '';
		}
	}
	
	getListingStatusName(puid: any) {
		if (puid) {
			const shortTermRental = this.properties.find((e: any) => e.shortTermRentalId == puid);
			const listingStatus = this.listingStatuses.find((e: any) => e.value === shortTermRental?.listingStatus);
			return listingStatus?.name;
		}
		else {
			return '';
		}
	}
	
	getPercentage(rateMarkup: any) {
		// console.log("rateMarkupUpdateValue :"+rateMarkup);
		const rateMarkupUpdateValue = (rateMarkup - 100) / 100;
		if (rateMarkup) {
			const status = this.percentageValuesPositiveAndNegative.find((e: any) => e.value == rateMarkupUpdateValue);
			return status?.name;
		}
		else {
			return '';
		}
	}

	exportSelected(exporttype: any) {
		this.importExportComponent.exporData(exporttype, this.ruPropertiesStatuss, 'RU Properties Status Report');
		}
}
